import React from "react";
import { HelpIcon, PurchaseButton } from "../../UIkit";
import "../../../assets/css/cheerTicket.css";
import Logo from "../../../assets/img/src/TimeBooth_logo_white.png";
import dayjs from "dayjs";

const CheerTicketBox = (props) => {
  const opusData = props.opusData[0];
  // console.log(opusData);
  const scheduleDate = dayjs(props.liveSchedule.toDate());
  const liveday = scheduleDate.format("M月D日");
  return (
    <div className="ticket-box--container center">
      <div className="cheer-header text-white">応援チケットを購入して</div>
      <div className="cheer-header text-white">クリエイターを応援しよう！</div>
      <div className="spacer-box--s" />
      <div className="text-white hover1">
        <HelpIcon
          title="応援チケットとは？"
          text="TimeBoothでは作品を購入するだけではなく、チケットを購入して参加するだけで応援している証(あかし)を手に入れることができます。購入したチケットはマイページのお気に入り(準備中)に記録として残ります。"
        />
      </div>
      <div className="spacer-box--s" />
      {opusData && (
        <>
          <div className="ticket-item-box center">
            <div className="ticket-box">
              <div className="ticket-logo-box">
                <img className="ticket-logo" src={Logo} alt="ロゴ画像" />
              </div>
              <img className="ticket-back" src={opusData.images[0].path} alt="アバター画像" />
              <div className="spacer-box--ss" />
              <div className="ticket-title-container">
                <div className="left text-lightGrey arial size-10">Title</div>
                {props.title}
                {/* 長いイベント名だって付ける人がいるかもしれない */}
              </div>
              <div className="spacer-box--sss" />
              <div className="ticket-day-container">
                <div className="left text-lightGrey arial size-10">Date</div>
                {liveday}
              </div>
            </div>
          </div>
          <div className="spacer-box--s" />
          <PurchaseButton
            label={props.cheerPrice + "円で応援"}
            price={props.cheerPrice}
            name="応援チケット"
            // images={opusData.images[0].path}
            boothId={props.boothId}
          />
        </>
      )}
      <div className="spacer-box--l" />
    </div>
  );
};
export default CheerTicketBox;
